// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ll3C","inner":"styles_inner__2ysRN","right":"styles_right__USijv","close":"styles_close__3oc3W","footer":"styles_footer__3iw0X"};